import { Fragment, useRef, useState } from "react";
import { ETableEditAction } from "../../Utils/Enums";
import { endpoints } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { clientCategoryValidationSchema } from "../../Utils/Models";
import { Button, Grid, TextField } from "@mui/material";
import { FormsIds, TablesIds } from "../../Utils/Constants";
import { ClientCategoryManagementProps } from "../../Utils/Types";
import { postData } from "../../Services/postData";
import { updateData } from "../../Services/updateData";
import { onFormError } from "../../Utils/Utils";

export default function ClientCategoryManagement(
  props: ClientCategoryManagementProps
) {
  const [renderTextField, setRenderTextField] = useState(false);
  const ref: any = useRef();
  const [customTriggerReload, setCustomTriggerReload] = useState<
    boolean | undefined
  >();
  const { register, watch, formState, handleSubmit, reset } = useForm({
    resolver: yupResolver(clientCategoryValidationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    context: undefined,
    shouldFocusError: true,
    shouldUnregister: false,
    criteriaMode: "firstError",
  });
  const clientCategoryColumns = [
    {
      label: Vocabulary.categoryName,
      name: "name",
      options: {
        sort: false,
      },
    },
  ];

  /**
   * create or update a client category
   * @param data
   */
  const onSubmit = (data: any) => {
    data._id ? updateElement(data) : createElement(data);
  };

  /**
   *
   * @param model
   */
  const createElement = (model: any) => {
    postData(endpoints.clientCategory.main, model).then((response) => {
      if (response && response.data) {
        ref.current.reset();
        reset();
        setCustomTriggerReload(!customTriggerReload);
        setRenderTextField(false);
      }
    });
  };

  /**
   *
   * @param model
   */
  const updateElement = (model: any) => {
    updateData(`${endpoints.clientCategory.main}/${model?._id}`, model).then(
      (response) => {
        ref.current.reset();
        reset();
        setCustomTriggerReload(!customTriggerReload);
        setRenderTextField(false);
      }
    );
  };

  return (
    <form
      ref={ref}
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(onSubmit, onFormError)(e);
      }}
      id={FormsIds.clientsCategory}
    >
      <Grid container spacing={2}>
        {renderTextField && (
          <Fragment>
            <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
              <TextField
                {...register("name")}
                name="name"
                id="name"
                label={Vocabulary.name}
                value={watch("name") || ""}
                fullWidth
                type="text"
                variant="outlined"
                error={typeof formState.errors.name === "object"}
                helperText={formState.errors.name?.message?.toString()}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <Button type="submit" variant="contained">
                {Vocabulary.save}
              </Button>
            </Grid>
          </Fragment>
        )}
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <MUIDataTableCustomStyle
            buttons={[]}
            onEditAction={ETableEditAction.INLINE}
            title={Vocabulary.clientCategory}
            handleInlineForm={(value: any) => {
              if (value) {
                reset(value);
                setRenderTextField(true);
              } else {
                setRenderTextField(!renderTextField);
              }
            }}
            id={TablesIds.clientCategories}
            columns={clientCategoryColumns}
            CRUDEndPoint={endpoints.clientCategory.main}
            customTriggerReload={customTriggerReload}
          />
        </Grid>
      </Grid>
    </form>
  );
}
